// Import React for creating the AboutUs component
import React from "react";
// Import CSS for About Us page styling
import "../css/AboutUs.css";
// Import reusable components and images
import Hero from "./components/Hero";
import Button from "./components/Button";
import OfficeImage from "../assets/images/businesswomen-doing-interview.jpg";
import KitchenImage from "../assets/images/interior-shot-modern-house-kitchen-with-large-windows.jpg";
import HeroIamge from "../assets/images/interior-shot-modern-house-kitchen-with-large-windows.jpg";
import Image1 from "../assets/images/interior-design-house-modern-white-kitchen.jpg";
import CarlyImage from "../assets/images/image0.jpeg";

// AboutUs component displays information about the founder and company values
const AboutUs = () => {
  return (
    <div className="about-us-page">
      {/* Hero Section with background image and title */}
      <Hero
        title="ABOUT US"
        subtitle=""
        backgroundImage={HeroIamge}
        titleAlign="center"
        subtitleAlign="center"
      />

      {/* About Section with founder's experience */}
      <section className="about-section">
        <div className="about-container">
          <div className="about-content">
            {/* <div className="about-label">ABOUT US</div> */}
            <h2 className="about-title">Experience</h2>
            <p className="about-text">
              As the Founder and Managing Director of a serviced accommodation
              portfolio in Hertfordshire, I have first-hand experience as both a
              borrower and an operator. I have extensive experience with
              portfolio landlords, refinances, multi-property structures and
              complex lending scenarios, and a strong background in financial
              analysis, cash flow planning and long-term asset strategy. This
              means that I can understand property finance from the client’s
              perspective, not just the broker’s desk. From complex lease
              structures, to developer agreements and lender criteria – I am
              focused on protecting my clients from risk.
            </p>
            {/* <Button text="FIND OUT MORE" variant="primary" /> */}
          </div>
          {/* Founder image */}
          <img src={CarlyImage} alt="Carly" />
        </div>
      </section>

      {/* Values Section describing company philosophy */}
      <section className="services-section">
        <h3>My Values</h3>
        <p className="services-description">
          <strong>
            {" "}
            I created Portfolio Finance to offer strategic, forward-thinking
            advice - not just transactional broking. I believe in establishing
            long-term client relationships rather than one-off deals.
          </strong>
          <br />
          {/* Spacer for visual separation */}
          <div style={{ height: 30 }}></div>
          Making sure my clients fully understand their options, and empowering
          them to make informed decisions is at the core of Portfolio Finance.
          Making financial decisions can be confusing enough without adding
          complex or unnecessary jargon, which is why I am to always be
          transparent, direct, and honest in my communication.
        </p>
      </section>
      {/* Decorative image at the bottom of the page */}
      <img className="about-image" src={Image1} alt="About Us Image" />
    </div>
  );
};

// Export the AboutUs component as default
export default AboutUs;
